import React from "react";
import styles from "./style.module.scss";
import FeatureHeaderImage from "Utils/Assets/Images/Ellipse1.png";
import pop from "Utils/Assets/Images/pop.png";
import VREventVideo from "Utils/Assets/Images/vr-event-video.mp4";

const FeatureEventHeader = () => {
    return (
        <div className={styles.featureHeaderWrapper}>
            <video
                className={styles.featureHeaderVideo}
                autoPlay
                muted
                loop
                playsInline
            >
                <source src={VREventVideo} type="video/mp4" />
            </video>

            <div className={styles.featureHeaderOverlay} />

            <div className={styles.featureHeaderContent}>
                <button className={styles.featureHeaderButton}>
                    Virtual Events
                </button>

                <div className={styles.featureHeaderText}>
                    <p className={styles.featureHeaderTitle}>
                        Host Virtual Events & Get{" "}
                        <span className={styles.titleBreak} /> Paid in MVR Coins!
                    </p>
                    <p className={styles.featureHeaderDesc}>
                        Create events, engage your audience, and earn MVR rewards with every interaction.
                    </p>
                </div>

                <div>
                    <button className={styles.featureHeaderJoinBtn}>
                        Start Hosting & Earning MVR!
                    </button>
                </div>

                <div className={styles.card}>
                    <div className={styles.pop}>
                        <img src={pop} alt="pop" />
                    </div>
                    <p className={styles.cardQuote}>
                        “I hosted my first MeetUsVR event and earned 2,000 MVR
                        in one session!”
                    </p>
                    <div className={styles.cardFooter}>
                        <img src={FeatureHeaderImage} alt="FeatureHeaderImage" />
                        <p className={styles.cardFooterName}>Farah Kareem</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeatureEventHeader;